<template>
	<div style="min-height: 281px; height: 281px">
		<b-row>
			<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
				<div class="sa-pianificazione-edit-container">
					<label for="">Ogni N giorni:</label>
					<b-form-input type="number" v-model="numeroGiorni"></b-form-input>
				</div>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
				<div class="sa-pianificazione-edit-container">
					<div style="display: flex; flex-direction: row">
						<div style="flex: 1">
							<b-row>
								<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
									<b-input-group class="mb-3">
										<label for="">Orario di Riferimento</label>
										<date-picker format="HH:mm" value-type="timestamp" v-model="orarioRiferimento" :disabled-time="disbilitaOrePrecedenti" placeholder="HH:mm" :default-value="new Date()" :minute-step="15" type="time"></date-picker>
									</b-input-group>
								</b-col>
							</b-row>
						</div>
					</div>
				</div>
			</b-col>
			<b-col cols="6" xs="6" sm="12" md="12" lg="12" xl="12">
				<div class="sa-pianificazione-edit-container">
					<label class="sa-label-data">Elenco delle prossime {{ numeroElencoProgrammato }} attività programmate:</label>
					<div v-for="(attivita, index) in elencoAttivitaProgrammate" :key="index" style="display: flex; flex-direction: row" :class="getClass(index)">
						<div style="flex: 1; display: table">
							<span style="display: table-cell; vertical-align: middle; font-size: var(--label-font-size)"> {{ index + 1 }} - {{ attivita }} </span>
						</div>
					</div>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
	mixins: [UtilityMixin],
	components: { DatePicker },
	data() {
		return {
			jsonDataSchedulazione: null,
			pianificazione: { params: {} },
			days: [],
			daysSelected: [],
			hoursSelected: [],
			btnDisabledAggiungiOrario: true,
			numeroGiorni: null,
			orarioRiferimento: null,
			numeroElencoProgrammato: 10,
			elencoAttivitaProgrammate: [],
		};
	},
	created() {
		this.days = UtilityMixin.methods.getDaysOfWeekArray();
	},
	mounted() {
		this.$emit("afterMounted");
	},
	watch: {
		jsonDataSchedulazione: {
			handler() {
				this.aggiornaOrari();
			},
			deep: true,
		},
		daysSelected() {
			let me = this;
			me.pianificazione.giorni = me.daysSelected ? me.daysSelected.join(",") : "";
			this.$emit("updatePianificazioneGiorniAlternati", me.pianificazione);
			if (me.daysSelected.length > 0) {
				me.orarioDisabled = false;
				me.btnDisabledAggiungiOrario = false;
			} else {
				me.hoursSelected = [];
				me.orarioDisabled = true;
				me.btnDisabledAggiungiOrario = true;
			}
		},
		hoursSelected() {
			let me = this;
			me.pianificazione.orari = me.hoursSelected ? me.hoursSelected.join(",") : "";
			this.$emit("updatePianificazioneGiorniAlternati", me.pianificazione);
		},
		numeroGiorni(value) {
			this.daysSelected = [];
			this.daysSelected.push(value);
			this.aggiornaOrari();
		},
		orarioRiferimento(value) {
			this.hoursSelected = [];
			this.hoursSelected.push(this.formatTime(value));
			this.$emit("updatePianificazioneGiorniAlternati", this.pianificazione);
			this.aggiornaOrari();
		},
	},
	methods: {
		init(jsonData) {
			let me = this;
			me.jsonDataSchedulazione = jsonData;
		},
		getClass(index) {
			if (index % 2 === 0) {
				return "sa-utility-alternate-even";
			} else {
				return "sa-utility-alternate-odd";
			}
		},
		aggiornaOrari() {
			let me = this;
			me.elencoAttivitaProgrammate = [];
			if (me.numeroGiorni && this.orarioRiferimento) {
				for (let x = 0; x < me.numeroElencoProgrammato; x++) {
					let dataRiferimento = new Date(me.jsonDataSchedulazione.dataInizio + me.numeroGiorni * x * 24 * 60 * 60 * 1000);
					let oraRiferimento = new Date(this.orarioRiferimento);
					dataRiferimento.setHours(oraRiferimento.getHours());
					dataRiferimento.setMinutes(oraRiferimento.getMinutes());

					me.elencoAttivitaProgrammate.push(me.formatDateTimeCustom(dataRiferimento, "dddd DD-MM-YYYY HH:mm"));
				}
			}
		},
		disbilitaOrePrecedenti(date) {
			let me = this;
			let today = new Date();
			let dataRiferimento = new Date(me.pianificazione.dataInizio);
			if (dataRiferimento.getFullYear() === today.getFullYear() && dataRiferimento.getMonth() === today.getMonth() && dataRiferimento.getDate() === today.getDate()) {
				return date.getHours() < new Date().getHours();
			} else {
				return false;
			}
		},
		setPianificazione(jsonDataSchedulazione, pianificazione) {
			let me = this;
			me.jsonDataSchedulazione = jsonDataSchedulazione;
			me.pianificazione = pianificazione;
			me.daysSelected = pianificazione.giorni ? pianificazione.giorni.split(",") : [];
			me.hoursSelected = pianificazione.orari ? pianificazione.orari.split(",") : [];
			me.numeroGiorni = me.pianificazione.giorni;
			me.orarioRiferimento = me.parseFormatDateTime(me.pianificazione.orari, "HH:mm").getTime();
		},
		onInputDaysAll(value) {
			let me = this;
			me.daysSelected = [];
			if (value) {
				this.days.forEach((element) => {
					me.daysSelected.push(element.code);
				});
			}
		},
		onClickRemoveOrario(index) {
			let me = this;
			me.hoursSelected.splice(index, 1);
		},
		onClickAggiungiOrario() {
			let me = this;
			if (this.oraSelezionata) {
				me.hoursSelected.push(me.formatTime(this.oraSelezionata));
				me.hoursSelected = [...new Set(me.hoursSelected)];
				me.hoursSelected.sort();
			}
		},
	},
};
</script>

<style></style>
